import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryGeneratePreviewArgs, BackendVariantPreview } from 'src/types/backend';

const QUERY = gql`
  query GeneratePreview($landingPageAssetId: ID!, $htmlText: String!) {
    generatePreview(landingPageAssetId: $landingPageAssetId, htmlText: $htmlText) {
      screenshotBase64
      screenshotId
      screenshotUrl
    }
  }
`;

type Variables = BackendQueryGeneratePreviewArgs;
type Result = BackendVariantPreview;

export const queryCOGeneratePreview = async (variables: Variables, options?: GqlQueryOptions) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options,
  });

  return getSingleProp<Result>(result.data);
};
